import { Session, STORAGE } from "../utils/types"
import { useCallback } from "react"
import Cookies from "js-cookie"

export const useStorage = () => {
  return {
    storeSession: useCallback((session: Session) => {
      Cookies.set(STORAGE.JWT, session.jwt, {
        sameSite: "strict",
        path: "/",
      })
      Cookies.set(STORAGE.ROLE, session.role, {
        sameSite: "strict",
        path: "/",
      })
      Cookies.set(STORAGE.USER_ID, session.userId, {
        sameSite: "strict",
        path: "/",
      })
    }, []),
    removeSession: useCallback(() => {
      Cookies.remove(STORAGE.JWT)
      Cookies.remove(STORAGE.ROLE)
      Cookies.remove(STORAGE.USER_ID)
    }, []),
    jwt: Cookies.get(STORAGE.JWT),
    userId: Cookies.get(STORAGE.USER_ID),
    role: Cookies.get(STORAGE.ROLE),
  }
}
